import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  cn,
} from '@parcel/ui';
import { ChevronDown } from 'lucide-react';
import { IMPACT_LABEL, SCORE_IMPACTS, type ScoreImpact } from './criteria-state.js';

const WEIGHTED = SCORE_IMPACTS.filter((impact) => impact !== 'disqualify');

export function ImpactSelect({
  value,
  disabled,
  onChange,
}: {
  value: ScoreImpact;
  disabled?: boolean;
  onChange: (impact: ScoreImpact) => void;
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={disabled}>
        <Button
          variant="outline"
          size="sm"
          aria-label="Impact"
          className={cn(
            'h-8 w-48 justify-between gap-2 px-2 font-normal',
            value === 'disqualify' && 'text-destructive',
          )}
        >
          <span className="truncate">{IMPACT_LABEL[value]}</span>
          <ChevronDown className="h-3.5 w-3.5 shrink-0 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuRadioGroup
          value={value}
          onValueChange={(next) => onChange(next as ScoreImpact)}
        >
          {WEIGHTED.map((impact) => (
            <DropdownMenuRadioItem key={impact} value={impact}>
              {IMPACT_LABEL[impact]}
            </DropdownMenuRadioItem>
          ))}
          <DropdownMenuSeparator />
          <DropdownMenuRadioItem value="disqualify" className="text-destructive">
            {IMPACT_LABEL.disqualify}
          </DropdownMenuRadioItem>
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
